import { CheckboxElement } from 'react-hook-form-mui';

export function Internal({ name, disabled, showInternal = false }) {
    if (!showInternal) return null;

    return <CheckboxElement name={name} label="Internal" disabled={disabled} />;
}
